<template>
  <div>
    <h1 class="mb-2">
      {{ $t('pages.onboarding.applicant.documents.heading') }}
    </h1>
    <p class="text--grey mb-5">
      {{ $t('pages.onboarding.applicant.documents.lead') }}
    </p>
    <step-form :applicant="applicant">
      <template #footer="{ invalid, loading }">
        <flow-step-footer :step="step" @prev="movePrev">
          <t-button-loading
            wide
            native-type="submit"
            :loading="loading"
            :disabled="invalid"
            @click="moveNext"
          >
            {{ $t('global.actions.continue') }}
          </t-button-loading>
        </flow-step-footer>
      </template>
    </step-form>
  </div>
</template>
<script>
import StepForm from './StepForm.vue';
import FlowStep from '~/components/Flows/FlowStep.vue';

export default FlowStep.extend({
  components: {
    StepForm,
  },

  props: {
    applicant: {
      type: Object,
      required: false,
      default: null,
    },
  },
});
</script>
